import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 13 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.314 0a2.438 2.438 0 1 1-.001 4.877 2.438 2.438 0 0 1 0-4.877Zm0 15.125A2.438 2.438 0 1 1 10.313 20a2.438 2.438 0 0 1 0-4.876Zm0-7.563a2.438 2.438 0 1 1-.001 4.877 2.438 2.438 0 0 1 0-4.877ZM2.438 0a2.438 2.438 0 1 1-.001 4.877 2.438 2.438 0 0 1 0-4.877Zm0 15.125A2.438 2.438 0 1 1 2.437 20a2.438 2.438 0 0 1 0-4.876Zm0-7.563a2.438 2.438 0 1 1-.001 4.877 2.438 2.438 0 0 1 0-4.877Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };